import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import "../../assets/css//onboarding.css";
import {
  addUser,
  updateUser,
  getUserDetails,
} from "../../services/Users-services";
import { toast } from "sonner";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,
} from "../../../src/services/utilityFunctions.js";
import "../../assets/css/stepper.css";
import { getLocalStorageData } from "../../../src/services/axiosComponent";
import { getOrganizationLevel } from "../../../src/services/OrganisationServices/organizationLevel";
import { useGlobalState } from "../../../src/services/hostelConst.js";
import Select from "react-select";
import { selectStyle } from "../../services/constant";
import { closeModal } from "../../services/redux/reducers/modalSlice";
import { useSelector, useDispatch } from "react-redux";
const AddUserForm = (props) => {
  var { refresh, navigate } = props;
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const modal = useSelector((state) => state.modal);

  // const id = modal.data._ID;

  const [currentStep, setCurrentStep] = useState(1);
  const [regionOptions, setRegionOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [organizationLevelOptions, setOrganizationLevelOptions] = useState([]);
  const [isOrganizationLevelLoading, setIsOrganizationLevelLoading] =
    useState(false);

  const [isSiteOptionsLoading, setIsSiteOptionsLoading] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const [isSiteSearchable, setIsSiteSearchable] = useState(true);
  const [isRegionSearchable, setIsRegionSearchable] = useState(true);
  const [loadingData, setLoadingData] = useState(modal.isEditing);

  const prepareFormData = (data = null) => {
    return {
      partnerInfo: {
        firstName: data?.["FIRST NAME"] || "",
        lastName: data?.["LAST NAME"] || "",
        email: data?.["EMAIL"] || "",
      },
      patnerInfo2: {
        dob: data?.["BIRTH DATE"] || "",
        gender: data?.["GENDER"] || "",
        maritalStatus: data?.["MARITAL STATUS"] || "",
      },
      siteInfo: {
        region: {
          value: data?.["_REGION"] || "",
          label: data?.["REGION"] || "",
        },
        site: {
          value: data?.["_SITE"] || "",
          label: data?.["SITE"] || "",
        },
        organizationLevel: {
          value: data?.["_ORGANIZATION LEVEL"] || "",
          label: data?.["ORGANIZATION LEVEL"] || "",
        },
      },
    };
  };
  const [formData, setFormData] = useState(prepareFormData());
  const getUserDetailsData = async () => {
    setLoadingData(true);

    var res = await getUserDetails(modal.data._ID);
    if (res.status == "success") {
      console.log(res.data, "res is hereeeeeeeeee");
      setData(res.data);
      setFormData(prepareFormData(res.data));
    } else {
      dispatch(closeModal());
      showErrorMessages({ data: res, navigate });
    }
    setLoadingData(false);
  };

const handleChange = (step, field, value) => {
  console.log(
    `handleChange called: step=${step}, field=${field}, value=${value}`
  );
  console.log("Current formData before change:", formData);

  setFormData((prevFormData) => {
    const newFormData = { ...prevFormData };

    if (field === "region") {
      // Handle region change specially
      newFormData.siteInfo = {
        ...newFormData.siteInfo,
        region: value,
        site: { value: "", label: "" },
      };
    } else {
      // Handle all other fields
      if (!newFormData[step]) {
        newFormData[step] = {};
      }
      newFormData[step] = {
        ...newFormData[step],
        [field]: value,
      };
    }

    console.log("New formData after change:", newFormData);
    return newFormData;
  });
};

  const getOrganizationLevelOptions = async () => {
    setIsOrganizationLevelLoading(true);
    var res = await getOrganizationLevel({
      type: "ORGANIZATION",
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
    });
    if (res.status === "success") {
      var list = [];
      res.data.map((item) => {
        list.push({ value: item._ID, label: item.NAME });
      });
      setOrganizationLevelOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setIsOrganizationLevelLoading(false);
  };
  const validateFields = () => {
    const currentForm = Object.entries(formData[getCurrentStepKey()]);
    const newErrors = {};
    if (currentStep == 1) {
      if (!formData.siteInfo.region.value)
        newErrors.region = "Region is required";
      if (!formData.siteInfo.site.value) newErrors.site = "Site is required";
      if (!formData.siteInfo.organizationLevel.value)
        newErrors.organizationLevel = "Organization Level is required";
    } else {
      currentForm.forEach(([key, value]) => {
        if (!value?.trim()) newErrors[key] = `${key} is required`;
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getCurrentStepKey = () => {
    switch (currentStep) {
      case 1:
        return "siteInfo";
      case 2:
        return "partnerInfo";
      case 3:
        return "patnerInfo2";

      default:
        return "siteInfo";
    }
  };

  const handleNext = async () => {
    if (validateFields()) {
      if (currentStep < 3) {
        setCurrentStep(currentStep + 1);
      } else {
        var dataToSubmit = {};
        Object.entries(formData).map(([key, value]) => {
          if (key == "siteInfo") return;
          Object.entries(value).map(([key1, value1]) => {
            dataToSubmit[key1] = value1;
          });
        });
        dataToSubmit.regionId = formData.siteInfo.region.value;
        dataToSubmit.siteId = formData.siteInfo.site.value;
        var profileDetails = getLocalStorageData("profileDetails");
        dataToSubmit.id = data == null ? "" : data["_ID"];
        dataToSubmit.organizationLevelId =
          formData.siteInfo.organizationLevel.value;
        dataToSubmit.organizationId = profileDetails["_ORGANIZATION_"]["_ID"];
        setLoading(true);

        var res =
          data == null
            ? await addUser(dataToSubmit)
            : await updateUser(dataToSubmit, data["_ID"]);
        console.log(res, "res is hereeeeeeeeee444");
        if (res.status == "fail") {
          var resError = showErrorMessages({
            data: res,
            navigate,
            formFilds: [
              ["regionId", "siteid"],
              ["firstName", "lastName", "email", "userMobile"],
              ["dob", "maritalStatus", "gender"],
            ],
          });
          if (resError != null || resError != undefined) {
            var step = 3;
            var error = {};
            Object.entries(resError).map(([key, value]) => {
              step = Math.min(step, value.step);
              error[key] = value.message;
            });
            setErrors(error);
            setCurrentStep(step);
          }
        } else {
          if (data == null)
            callToast("success", "Created", "User added successfully");
          else callToast("success", "Updated", "User updated successfully");
          await refresh({ columnRefresh: false, isLoading: false });

          dispatch(closeModal());

          setTimeout(() => {
            setLoading(false);
            // navigate(-1);
          }, 500);
          // navigate("/");
        }
        setLoading(false);
      }
    }
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const getSiteList = async (regionId, query = null) => {
    setIsSiteOptionsLoading(true);
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = await prepareSiteList(regionId, navigate, query);

    if (
      list.length == 1 &&
      list[0].value == data["_SITE"] &&
      data["_SITE ACCESS_"] == null
    ) {
      setIsSiteSearchable(false);
      handleChange("siteInfo", "site", {
        value: list[0].value,
        label: list[0].label,
      });
    }

    setIsSiteOptionsLoading(false);
    if (list.length == 0) {
      setErrors((prev) => ({
        ...prev,
        site: "No site available for this region",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        site: "",
      }));
    }
    setSiteOptions(list);
  };

  const getRegionList = async () => {
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = JSON.parse(localStorage.getItem("regionList"));
    console.log(list, "list is hereeeeeeeeee");
    if (
      list.length == 1 &&
      list[0].value == data["_REGION"] &&
      data["_REGION_ACCESS_"] == null
    ) {
      setIsRegionSearchable(false);
      handleChange("siteInfo", "region", {
        value: list[0].value,
        label: list[0].label,
      });
    }
    setRegionOptions(list);
  };
  useEffect(() => {
    getRegionList();
    getOrganizationLevelOptions();
    if (modal.isEditing == true) {
      getUserDetailsData();
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div
            id="myToastButton"
            class="pixel-corners"
            style={{ display: "block" }}
          ></div>
          <div className=" m-5 mt-1 ">
            <div className="d-flex">
              <div className="w-100">
                <div className="stepper mb-3 ">
                  <div className="d-flex justify-content-between">
                    <div
                      className={`step ${currentStep === 1 ? "active" : ""}`}
                    >
                      Organization Info
                    </div>
                    <div
                      className={`step ${currentStep === 2 ? "active" : ""}`}
                    >
                      User Info
                    </div>
                    <div
                      className={`step ${currentStep === 3 ? "active" : ""}`}
                    >
                      User Info
                    </div>
                  </div>
                </div>

                <form>
                  {currentStep === 1 ? (
                    <>
                      <div className="mb-3 ">
                        <label className="form-label">Region </label>

                        <Select
                          options={regionOptions}
                          value={
                            formData.siteInfo.region.label == ""
                              ? null
                              : formData.siteInfo.region
                          }
                          styles={selectStyle}
                          onChange={(newValue) => {
                            handleChange(
                              "siteInfo",
                              "region",
                              newValue == null
                                ? { value: "", label: "" }
                                : newValue
                            );

                            if (newValue != null) {
                              getSiteList(newValue.value);
                            }
                          }}
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") {
                            }
                          }}
                          noOptionsMessage={() => {
                            return !isRegionSearchable
                              ? "Region Access not available"
                              : "No matches found";
                          }}
                          isSearchable={isRegionSearchable}
                          placeholder="Select Region"
                          className="basic-single"
                          classNamePrefix="select"
                          filterOption={(option, inputValue) =>
                            option.label
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                          }
                        />
                        {errors.region && (
                          <small className="text-danger">{errors.region}</small>
                        )}
                      </div>

                      <div className="mb-3 ">
                        <label className="form-label">Site</label>

                        <Select
                          styles={selectStyle}
                          options={siteOptions}
                          value={
                            formData.siteInfo.site.label == ""
                              ? null
                              : formData.siteInfo.site
                          }
                          components={
                            isSiteOptionsLoading
                              ? {
                                  DropdownIndicator,
                                }
                              : null
                          }
                          onChange={(newValue) => {
                            handleChange(
                              "siteInfo",
                              "site",
                              newValue == null
                                ? { value: "", label: "" }
                                : newValue
                            );
                          }}
                          onInputChange={(inputValue, { action }) => {
                            getSiteList(
                              formData.siteInfo.region.value,
                              inputValue
                            );
                          }}
                          noOptionsMessage={() => {
                            return !isSiteSearchable
                              ? "Site Access Not available"
                              : "No matches found";
                          }}
                          isSearchable={isSiteSearchable}
                          placeholder="Select Site "
                          className="basic-single"
                          classNamePrefix="select"
                          filterOption={(option, inputValue) =>
                            option.label
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                          }
                        />
                        {errors.site && (
                          <small className="text-danger">{errors.site}</small>
                        )}
                      </div>

                      <div className="mb-3 ">
                        <label className="form-label">User Level</label>

                        <Select
                          styles={selectStyle}
                          options={organizationLevelOptions}
                          value={
                            formData.siteInfo.organizationLevel.label == ""
                              ? null
                              : formData.siteInfo.organizationLevel
                          }
                          components={
                            isOrganizationLevelLoading
                              ? {
                                  DropdownIndicator,
                                }
                              : null
                          }
                          onChange={(newValue) => {
                            handleChange(
                              "siteInfo",
                              "organizationLevel",
                              newValue == null
                                ? { value: "", label: "" }
                                : newValue
                            );
                          }}
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") {
                            }
                          }}
                          noOptionsMessage={() => {
                            return !isOrganizationLevelLoading
                              ? "Organization Level Not available"
                              : "No matches found";
                          }}
                          isSearchable={!isOrganizationLevelLoading}
                          placeholder="Select Site "
                          className="basic-single"
                          classNamePrefix="select"
                          filterOption={(option, inputValue) =>
                            option.label
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                          }
                        />
                        {errors.organizationLevel && (
                          <small className="text-danger">
                            {errors.organizationLevel}
                          </small>
                        )}
                      </div>
                    </>
                  ) : currentStep === 2 ? (
                    <>
                      <div className="mb-3">
                        <div className="form-row ">
                          <div class="col mb-2">
                            <label className="form-label">First Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter First Name"
                              value={formData[getCurrentStepKey()].firstName}
                              onChange={(e) =>
                                handleChange(
                                  getCurrentStepKey(),
                                  "firstName",
                                  e.target.value
                                )
                              }
                            />
                            {errors.firstName && (
                              <small className="text-danger">
                                {errors.firstName}
                              </small>
                            )}
                          </div>
                          <div className="col  ">
                            <label className="form-label">Last Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter last Name"
                              value={formData[getCurrentStepKey()].lastName}
                              onChange={(e) =>
                                handleChange(
                                  getCurrentStepKey(),
                                  "lastName",
                                  e.target.value
                                )
                              }
                            />
                            {errors.lastName && (
                              <small className="text-danger">
                                {errors.lastName}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Email"
                          value={formData[getCurrentStepKey()].email}
                          onChange={(e) =>
                            handleChange(
                              getCurrentStepKey(),
                              "email",
                              e.target.value
                            )
                          }
                        />
                        {errors.email && (
                          <small className="text-danger">{errors.email}</small>
                        )}
                      </div>
                    </>
                  ) : currentStep === 3 ? (
                    <>
                      {" "}
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <div class="col">
                            <label className="form-label">Date of Birth</label>
                          </div>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={
                                formData.patnerInfo2.dob == ""
                                  ? null
                                  : dayjs(formData.patnerInfo2.dob)
                              }
                              onChange={(e) => {
                                handleChange(
                                  "patnerInfo2",
                                  "dob",
                                  e.format("DD/MM/YYYY").toString()
                                );
                              }}
                            />
                          </LocalizationProvider>

                          <div className="col">
                            {errors.dob && (
                              <small className="text-danger">
                                {errors.dob}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>{" "}
                      <div className="col-md-6 mb-4 mt-3">
                        <div className="col-md-6 mb-1">
                          <label className="form-label">Marital Status</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="maritalStatus"
                            id="married"
                            checked={
                              formData.patnerInfo2?.maritalStatus === "MARRIED"
                            }
                            onChange={() => {
                              console.log("Setting marital status to MARRIED");
                              setFormData((prev) => ({
                                ...prev,
                                patnerInfo2: {
                                  ...prev.patnerInfo2,
                                  maritalStatus: "MARRIED",
                                },
                              }));
                            }}
                            value="MARRIED"
                          />
                          <label className="form-check-label" htmlFor="married">
                            Married
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="maritalStatus"
                            id="unmarried"
                            checked={
                              formData.patnerInfo2?.maritalStatus ===
                              "UNMARRIED"
                            }
                            onChange={() => {
                              console.log(
                                "Setting marital status to UNMARRIED"
                              );
                              setFormData((prev) => ({
                                ...prev,
                                patnerInfo2: {
                                  ...prev.patnerInfo2,
                                  maritalStatus: "UNMARRIED",
                                },
                              }));
                            }}
                            value="UNMARRIED"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="unmarried"
                          >
                            Unmarried
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="maritalStatus"
                            id="widow"
                            checked={
                              formData.patnerInfo2?.maritalStatus === "WIDOW"
                            }
                            onChange={() => {
                              console.log("Setting marital status to WIDOW");
                              setFormData((prev) => ({
                                ...prev,
                                patnerInfo2: {
                                  ...prev.patnerInfo2,
                                  maritalStatus: "WIDOW",
                                },
                              }));
                            }}
                            value="WIDOW"
                          />
                          <label className="form-check-label" htmlFor="widow">
                            Widow
                          </label>
                        </div>
                        {errors.maritalStatus && (
                          <div className="col">
                            <small className="text-danger">
                              {errors.maritalStatus}
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3 mt-3">
                        <label className="form-label mb-2">Gender</label>
                        <div className="d-flex align-items-center gap-4">
                          <div className="form-check form-check-inline m-0">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              id="male"
                              checked={formData.patnerInfo2?.gender === "MALE"}
                              onChange={() => {
                                console.log("Setting gender to MALE");
                                setFormData((prev) => ({
                                  ...prev,
                                  patnerInfo2: {
                                    ...prev.patnerInfo2,
                                    gender: "MALE",
                                  },
                                }));
                              }}
                              value="MALE"
                            />
                            <label className="form-check-label" htmlFor="male">
                              Male
                            </label>
                          </div>
                          <div className="form-check form-check-inline m-0">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              id="female"
                              checked={
                                formData.patnerInfo2?.gender === "FEMALE"
                              }
                              onChange={() => {
                                console.log("Setting gender to FEMALE");
                                setFormData((prev) => ({
                                  ...prev,
                                  patnerInfo2: {
                                    ...prev.patnerInfo2,
                                    gender: "FEMALE",
                                  },
                                }));
                              }}
                              value="FEMALE"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="female"
                            >
                              Female
                            </label>
                          </div>
                          <div className="form-check form-check-inline m-0">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              id="transgender"
                              checked={
                                formData.patnerInfo2?.gender === "TRANSGENDER"
                              }
                              onChange={() => {
                                console.log("Setting gender to TRANSGENDER");
                                setFormData((prev) => ({
                                  ...prev,
                                  patnerInfo2: {
                                    ...prev.patnerInfo2,
                                    gender: "TRANSGENDER",
                                  },
                                }));
                              }}
                              value="TRANSGENDER"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="transgender"
                            >
                              Transgender
                            </label>
                          </div>
                        </div>
                        {errors.gender && (
                          <div className="col mt-1">
                            <small className="text-danger">
                              {errors.gender}
                            </small>
                          </div>
                        )}
                      </div>
                    </>
                  ) : null}
                  <div className="d-flex justify-content-end mt-4 gap-2">
                    {currentStep > 1 && (
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleBack}
                        disabled={loading}
                      >
                        Back
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleNext}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : currentStep < 3 ? (
                        "Next"
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddUserForm;
